import cx from "classnames";
import React from "react";

import { OTHER_CATEGORY_SLUG, UNCATEGORIZED_TOPIC_SLUG } from "@/mk2/apps/forum/constants";
import { forumPostNewInTopicUrl } from "@/mk2/apps/forum/urls";
import { Img } from "@/mk2/components/Img";
import { Link } from "@/mk2/components/Link";
import { Panel } from "@/mk2/components/Panel";
import { url } from "@/mk2/helpers/urls";
import { UserEntity } from "@/mk2/schemas";
import { TRY_FORUM_PANEL__BTN, TRY_FORUM_PANEL__TEXT } from "@/mk/autogenerated/translations/UnsatisfiedWithResultsTryForum.8083b59141d4dc76b1271bf2a6ffcba4";
import assetUrl from "@/mk/common/assetUrl";

import styles from "./UnsatisfiedWithResultsTryForum.mscss";

interface OwnProps {
    className?: string;
    requestUser: UserEntity;
    onAddClick?();
}

export const UnsatisfiedWithResultsTryForum = React.memo<OwnProps>(
    ({ className, onAddClick, requestUser }) => (
        <Panel className={cx(styles.UnsatisfiedWithResultsTryForum, className)}>
            <div className={cx(styles.UnsatisfiedWithResultsTryForum__wrapper)}>
                <div className={cx(styles.UnsatisfiedWithResultsTryForum__left)}>
                    <Img
                        className={styles.UnsatisfiedWithResultsTryForum__image}
                        src={assetUrl + "img/site_specific/browsing_pony.png"}
                        width={85}
                        height={97}
                        alt="sticker browsing pony"
                    />
                </div>
                <div className={cx(styles.UnsatisfiedWithResultsTryForum__right)}>
                    <span className={styles.UnsatisfiedWithResultsTryForum__text}>
                        {TRY_FORUM_PANEL__TEXT}
                    </span>
                    <Link
                        className={styles.UnsatisfiedWithResultsTryForum__btn}
                        onClick={onAddClick}
                        to={url(forumPostNewInTopicUrl, {
                            categorySlug: OTHER_CATEGORY_SLUG,
                            topicSlug: UNCATEGORIZED_TOPIC_SLUG,
                        })}
                    >
                        {TRY_FORUM_PANEL__BTN}
                    </Link>
                </div>
            </div>
        </Panel>
    ),
);
